<template>
  <div :class="`vue-filter ${name}-filter`">
    <label v-if="label">{{ label }}</label>

    <div class="filter-wrapper">
      <Select
        :name="name"
        v-model="model"
        :options="options"
        :value="value"
      ></Select>
    </div>
  </div>
</template>

<script>
import Select from "@/components/Form/Select"

export default {
  name: "SelectFilter",
  emits: ["change"],
  directives: {},
  components: {
    Select,
  },
  props: {
    name: {
      type: String,
      required: true,
      default: () => "filter"
    },
    label: {
      type: String,
      required: false,
      default: () => ""
    },
    value: {
      type: String,
      required: false,
      default() {
        return ""
      }
    },
    options: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    list: {type: Object}
  },
  data() {
    return {
      model: this.value,
      config: {},
      Drupal: this.$drupal,
    }
  },
  watch: {
    model: {
      deep: true,
      handler(to, from) {
        if (!this.$helpers.isEqual(from, to)) {
          this.updateValue()
        }
      },
    },
    value: {
      deep: true,
      handler(to, from) {
        if (!this.$helpers.isEqual(from, to)) {
          this.model = to
        }
      },
    },
  },
  methods: {
    updateValue() {
      // Emit changes to our parent.
      this.$emit("change", this.model)
    },
  }
}
</script>
